// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tableContainer___0Ed5v{padding:16px;background:var(--white);margin-top:16px;flex-grow:1}\n", "",{"version":3,"sources":["webpack://./src/routes/Reports/components/ReportsTable/ReportsTable.css"],"names":[],"mappings":"AAAA,wBAAA,YAAA,CAEI,uBAAA,CACA,eAAA,CACA,WAAA","sourcesContent":[".tableContainer {\n    padding: 16px;\n    background: var(--white);\n    margin-top: 16px;\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": "tableContainer___0Ed5v"
};
export default ___CSS_LOADER_EXPORT___;
